import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import SelectBox from "./Select";
import { get, post } from "../services/apiService";

const EditPopupForm = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    refetch,
    popup,
    notify,
    getPopupList,
    brands
  } = props;

  const token = localStorage.getItem("token");

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [formData, setFormData] = useState({
    title: popup.title,
    description: popup.description,
    image: popup.image,
    url: popup.image,
    button_text: popup.image,
    brand_id: popup.brand_id,
  });
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      await uploadImage(file);
    }
  };

  const uploadImage = async (file) => {
    try {
      const formImageData = new FormData();
      formImageData.append("file_name", file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}file-upload`,
        formImageData,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Image uploaded successfully:", response.data.path);
      setFormData((prev) => ({ ...prev, image: response.data.path }));
    } catch (error) {
      console.error("Error uploading image:", error);
      //alert("Failed to upload image.");
      notify(error, "error");
    }
  };


  const handleUpdate = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}popups/${popup.id}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Popup updated successfully:", response.data);
      //alert("Popup updated successfully!");
      getPopupList();
      notify(response.data.message, "success");
    } catch (error) {
      console.error("Error updating Popup:", error);
      //alert("Failed to update Popup.");
      notify(error, "error");
    }
  };

  const handleChangeSelect = (name, option) => {
    const { value, label } = option;
    //console.log("option", option , "name", name);
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      {console.log("edit", brands)}
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Title
        </label>
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={(e) =>
            setFormData({
              ...formData,
              title: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
         URL
        </label>
        <input
          type="text"
          name="url"
          placeholder="URL"
          value={formData.url}
          onChange={(e) =>
            setFormData({
              ...formData,
              url: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
         Button Text
        </label>
        <input
          type="text"
          name="button_text"
          placeholder="Button Text"
          value={formData.button_text}
          onChange={(e) =>
            setFormData({
              ...formData,
              button_text: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="flex flex-col ">
        <div className="w-full relative mt-2">
          <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold">
            Description
          </label>
          <textarea
            type="text"
            name="description"
            value={formData.description}
            onChange={(e) =>
              setFormData({
                ...formData,
                description: e.target.value,
              })
            }
            placeholder="Description"
            className="input input-bordered border-[#C1CFEF] border-[1px] focus:outline-none  w-full  h-20 pt-2 rounded-xl bg-white resize-none"
          />
        </div>

        <div className="flex flex-col ">
          <div className="w-full relative mt-2">
            <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold z-50">
              Brand
            </label>
            <SelectBox
              name="brand_id"
              options={brands}
              value={formData?.brand_id}
              onChange={handleChangeSelect.bind(this, "brand_id")}
              // error={formErrors.brand_id}
              // setFormErrors={setFormErrors}
              placeholder="Select Brand"
            />
          </div>
        </div>

        <div className="flex flex-col">
          <div className="w-full relative mt-2 md:pl-3">
            <input type="file" accept="image/*" onChange={handleImageChange} />
            {formData.image && (
              <img
                src={formData.image}
                alt="Preview"
                className="w-32 h-32 mt-2"
              />
            )}
          </div>
        </div>

        <div>
          <button
            onClick={handleUpdate}
            className="cursor-pointer w-full mt-4 bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPopupForm;
